import { cn } from '@/lib/cn';
import { useAuthSession } from '@/api';
import { AuthHeader } from './AuthHeader';
import { Brand } from './Brand';

export interface MobileHeaderProps {
  className?: string;
  logoUrl?: string | null;
}

export function MobileHeader({ className, logoUrl }: MobileHeaderProps) {
  const { loggedIn } = useAuthSession();

  return (
    <header
      className={cn(
        'bg-chrome-header sticky top-0 z-30 flex h-14 items-center gap-3 border-b',
        'border-border-subtle px-4 lg:hidden',
        className,
      )}
    >
      <Brand className="flex-1" logoUrl={logoUrl} />

      <AuthHeader loggedIn={loggedIn} />
    </header>
  );
}
